import { Component } from "@angular/core";
import { PageProdutoComponent } from "../../page-produto.component";

@Component({
  selector: "app-produto-cor",
  templateUrl: "./produto-cor.component.html",
  styleUrls: ["./produto-cor.component.css"],
})
export class ProdutoCorComponent {
  corJanela = 0;
  readonly coresVisiveisQtd = 5;

  constructor(public page: PageProdutoComponent) {}

  get coresLista(): any[] {
    return this.page.imagens ?? [];
  }

  get coresVisiveis(): any[] {
    return this.coresLista.slice(this.corJanela, this.corJanela + this.coresVisiveisQtd);
  }

  moverCores(direcao: number): void {
    const max = Math.max(0, this.coresLista.length - this.coresVisiveisQtd);
    this.corJanela = Math.min(max, Math.max(0, this.corJanela + direcao));
  }

  selecionarCor(img: any): void {
    this.page.selecionarCorMv2(img?.cor);
  }
}

